import { render } from "./DownloadCucumber.vue?vue&type=template&id=ba03bd56"
import script from "./DownloadCucumber.vue?vue&type=script&lang=js"
export * from "./DownloadCucumber.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__